<template>
    <div class="dashboard_0">
      <el-row v-if="ticketViewList && ticketViewList.length > 0" :gutter="4">
        <el-col 
            :span="6"
            v-for = "each in ticketViewList"
            :key = "each.id">

          <DashboardTicketTable :view = "each"/>
        </el-col>
      </el-row>

      <div v-else>
        <div style="margin:1vw;font-size:5vw;color:#efefef;">未配置 Dashboard</div>
        <div style="margin:1vw;font-size:2vw;color:#efefef;">可通过 设置 > 视图管理 配置</div>
      </div>
    </div>
</template>

<script>
export default {
  name: "TicketDashboard",

  data() {
    return {
      ticketViewList : []
    };
  },

  mounted() {
    var _this = this;

    sdk.TicketViewApi().listByUserIdCached({
      userId : -999, // -999 Dashboard
      page : { pageSize : 999 }
    }).then(res => {
      _this.ticketViewList = res;
    });
  }
};
</script>

<style>
  .dashboard_0 {
    border-left: 3px solid #f5f6fb;
    min-height: calc(100vh - 61px);
    padding:0 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketDashboard.vue